import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./configs/authConfig";
import { AuthProvider } from "./contexts/AuthContext";
import { AppConfigProvider } from "./contexts/AppConfigContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { symphonySVGs } from "./configs/iconConfig";
import { IconProvider, ToastProvider } from "cai-fusion";
import { SignalRProvider } from "./components/symphony/contexts/SignalRContext";
import env from "./configs/envConfig";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <AuthProvider>
                <AppConfigProvider>
                    <IconProvider svgs={symphonySVGs}>
                        <ToastProvider>
                            <SignalRProvider>
                                <NotificationProvider>
                                    <div data-theme={env.REACT_APP_THEME ?? ""} >
                                        <App />
                                    </div>
                                </NotificationProvider>
                            </SignalRProvider>
                        </ToastProvider>
                    </IconProvider>
                </AppConfigProvider>
            </AuthProvider>
        </MsalProvider>
    </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
